import React from 'react';
import { getTheme } from 'office-ui-fabric-react';
import { replaceSpacesWithDash } from 'buzz_lib_shared';
import { CardLink } from '../CardLink';
import { Icon } from '../Icons';
import { Tooltip } from '../Tooltip';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ClientCard = props => /*#__PURE__*/_jsx(CardLink, {
  code: props.Code,
  text: props.Name,
  href: props.href,
  testId: "client-data-".concat(replaceSpacesWithDash(props.Id)),
  isDisabled: props.isDisabled,
  children: props.isDisabled && /*#__PURE__*/_jsx(Tooltip, {
    "data-id": 'client-warnings',
    tooltipBody: /*#__PURE__*/_jsx(_Fragment, {
      children: props.tooltipMessage
    }),
    styles: {
      root: {
        alignSelf: 'flex-start',
        marginLeft: 'auto !important'
      }
    },
    children: /*#__PURE__*/_jsx(Icon, {
      "data-id": "warning-icon-".concat(replaceSpacesWithDash(props.Id)),
      iconName: 'Warning',
      styles: {
        root: {
          color: getTheme().palette.neutralSecondary
        }
      }
    })
  })
});